/*
 * Menu déroulant du fil d'Ariane.
 *
 * Le repliement des niveaux intermédiaires est désormais rendu côté serveur
 * (inc/parts/breadcrumb-page.php). Ce script se contentait auparavant de masquer
 * les éléments après le premier rendu, ce qui décalait le reste du fil de plusieurs
 * centaines de pixels et pesait lourdement sur le CLS. Il ne gère plus que
 * l'ouverture du menu.
 */
const breadCrumbContainer = document.querySelector('.page-template__breadcrumb');

if (breadCrumbContainer) {
    const dropdownMenu = breadCrumbContainer.querySelector('.page-template__breadcrumb-dropdown-menu');
    const dropdownToggle = dropdownMenu?.parentElement.querySelector('.page-template__breadcrumb-list-link');

    if (dropdownMenu && dropdownToggle) {
        dropdownToggle.addEventListener('click', (e) => {
            e.preventDefault();
            const isOpen = dropdownMenu.classList.toggle('page-template__breadcrumb-dropdown-menu--open');
            dropdownToggle.setAttribute('aria-expanded', String(isOpen));
        });
    }
}
